module.exports = __webpack_public_path__ + "img/stateThreeDesignate.5d294a18.png";